<template>
	<div>
		<div v-show='vw < 640'>
			<div class="owl-carousel" :key='new Date().getTime()'>
				<!-- <pre>{{items}}</pre> -->
				<template v-for='item in items'>
					<div class="item">
						<div class="image" :style='`background-image: url(${item.img})`'></div>
					</div>
				</template>
			</div>
		</div>
		
		<div v-show='vw >= 640'>
			<div class="flying-screens">
				<template v-for='(item, i) in items'>
					<div :class='`item n-${i}`' :style='`background-image: url(${item.img})`'></div>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
module.exports = {
	
	props: ['data'],
	
	data () {
		return {
			vw: window.innerWidth
		}
	},
	
	computed: {
		items() {
			return this.data ? this.data.items : [];
		}
	},
	
	updated() {
		this.$emit('updated', {
			owlSettings: {
				items: 1,
				loop: this.items.length > 1 ? true : false,
				// loop: false,
				nav: true,
				dots: true,
				navSpeed: 400,
				dragEndSpeed: 400,
				dotsSpeed: 400,
				onTranslate: () => {
					this.$parent.$el.classList.add('disabled');
				},
				onTranslated: () => {
					this.$parent.$el.classList.remove('disabled');
				}
			}
		});
	},
	
	mounted() {
		window.addEventListener('resize', () => {
			this.vw = window.innerWidth;
		})
	}
}
</script>

<style lang="scss">
@import "scss/wanted";

.global-slider-container {
	
	&.disabled {
		.slider-project-slider-2 {
			@include pointer-events(none);
			touch-action: manipulation;
		}
	}
	
	.slider-project-slider-2 {
		// overflow: hidden;
		touch-action: manipulation;
		background: url('#{$imgPathSCSS}iphone.png') no-repeat center;
		height: 350px;
		width: 290px;
		background-size: auto 100%;
		padding: 40px 79px 0 74px;
		position: relative;
		margin: 0 auto 74px;
		@include m_up {
			width: auto;
			padding: 0;
			margin: 0 auto 53px;
		};
		@include m___up {
			height: 470px;
			margin: 0 auto 46px;
		};
		@include l__up {
			height: 591px;
			margin: 0 auto 38px;
		};
		@include l___up {
			height: 704px;
			margin: 0 auto 33px;
		};
		
		.owl-carousel {
			// background-color: rgba(#000, .1);
			
			.item {
				
				.image {
					background-position: center top;
					background-size: cover;
					height: 246px;
				}
			}
			
			.owl-nav {
				height: 50px;
				// background-color: rgba(red, .1);
				display: flex;
				justify-content: space-between;
				align-items: center;
				
				.owl-prev, .owl-next {
					width: 32px;
					height: 32px;
					font-size: 0;
					background: url('#{$imgPathSCSS}ps1-prev.png') no-repeat center;
					background-size: 100% 100%;
					@include single-transition;
					position: absolute;
					top: calc(50% - 16px);
					
					&:hover {
						background-image: url('#{$imgPathSCSS}ps1-prev-a.png');
					}
				}
				
				.owl-prev {
					left: 0;
				}
				
				.owl-next {
					right: 0;
					@include rotate(180deg);
				}
			}
			
			.owl-dots {
				position: absolute;
				left: 50px;
				right: 50px;
				bottom: -37px;
				height: 50px;
				// background-color: rgba(green, .1);
				display: flex;
				justify-content: center;
				align-items: center;
				@include pointer-events(none);
				touch-action: manipulation;
				@include m__up {
					bottom: -65px;
				};
				@include m___up {
					bottom: -85px;
				};
				@include l___up {
					bottom: -112px;
				};
				
				.owl-dot {
					border: 2px solid #BABABD;
					position: relative;
					border-radius: 100%;
					opacity: .5;
					width: 12px;
					height: 12px;
					margin: 0 4px;
					@include single-transition;
					@include m__up {
						width: 18px;
						height: 18px;
						margin: 0 7px;
					};
					
					&.active {
						opacity: 1;
						&:after {
							opacity: 1;
						}
					}
					
					&:after {
						content: '';
						display: block;
						background-color: #BABABD;
						position: absolute;
						border-radius: 100%;
						opacity: 0;
						@include single-transition;
						width: 4px;
						height: 4px;
						top: calc(50% - 2px);
						left: calc(50% - 2px);
						@include m__up {
							width: 6px;
							height: 6px;
							top: calc(50% - 3px);
							left: calc(50% - 3px);
						};
					}
				}
			}
		}
		
		.flying-screens {
			position: absolute;
			top: 0;
			width: 690px;
			left: calc(50% - 690px / 2);
			background-color: rgba(red, .1);
			@include m___up {
				width: 930px;
				left: calc(50% - 930px / 2);
			};
			@include l__up {
				width: 1170px;
				left: calc(50% - 1170px / 2);
			};
			@include l___up {
				width: 1320px;
				left: calc(50% - 1320px / 2);
			};
			
			.item {
				position: absolute;
				background-repeat: no-repeat;
				background-position: center top;
				background-size: 100% 100%;
				transition: all 1000ms cubic-bezier(.16,.35,.07,.63) 0ms;
				
				&:after {
					content: '';
					display: block;
					position: absolute;
					top: 0;
					right: 0;
					bottom: 0;
					left: 0;
					background-size: auto 100%;
				}
				
				&.n-0 {
					z-index: -2;
					left: 0;
					top: 47px;
					width: 131px;
					height: 232px;
					@include translateX(271px);
					@include m___up {
						width: 176px;
						height: 312px;
						top: 63px;
						@include translateX(358px);
					};
					@include l__up {
						width: 221px;
						height: 393px;
						top: 79px;
						@include translateX(450px);
					};
					@include l___up {
						width: 248px;
						height: 443px;
						top: 94px;
						@include translateX(498px);
					};
					
					&:after {
						background-image: url('#{$imgPathSCSS}shadow-1.png');
						background-position: right center;
					}
				}
				&.n-1 {
					z-index: -1;
					left: 129px;
					width: 138px;
					height: 247px;
					top: 40px;
					@include translateX(137px);
					@include m___up {
						width: 186px;
						height: 331px;
						left: 175px;
						top: 54px;
						@include translateX(183px);
					};
					@include l__up {
						width: 234px;
						height: 416px;
						left: 220px;
						top: 68px;
						@include translateX(261px);
					};
					@include l___up {
						width: 264px;
						height: 470px;
						left: 245px;
						top: 80px;
					};

					&:after {
						background-image: url('#{$imgPathSCSS}shadow-2.png');
						background-position: right center;
					}
				}
				
				&.n-2 {
					left: calc(50% - 138px / 2);
					width: 138px;
					height: 247px;
					top: 40px;
					@include m___up {
						width: 186px;
						height: 331px;
						left: calc(50% - 188px / 2);
						top: 54px;
					};
					@include l__up {
						width: 234px;
						height: 416px;
						left: calc((50% - 234px / 2) - 3px);
						top: 68px;
					};
					@include l___up {
						width: 264px;
						height: 470px;
						left: calc((50% - 264px / 2) - 5px);
						top: 80px;
					};
				}
				
				&.n-3 {
					z-index: -1;
					right: 130px;
					width: 138px;
					height: 247px;
					top: 40px;
					@include translateX(-137px);
					@include m___up {
						width: 186px;
						height: 331px;
						right: 175px;
						top: 54px;
						@include translateX(-187px);
					};
					@include l__up {
						width: 234px;
						height: 416px;
						right: 220px;
						top: 68px;
						@include translateX(-261px);
					};
					@include l___up {
						width: 264px;
						height: 470px;
						right: 245px;
						top: 80px;
					};
					
					&:after {
						background-image: url('#{$imgPathSCSS}shadow-3.png');
						background-position: left center;
					}
				}
				
				&.n-4 {
					z-index: -2;
					right: 0;
					width: 131px;
					height: 232px;
					top: 47px;
					@include translateX(-271px);
					@include m___up {
						width: 176px;
						height: 312px;
						top: 63px;
						@include translateX(-362px);
					};
					@include l__up {
						width: 221px;
						height: 393px;
						top: 79px;
						@include translateX(-457px);
					};
					@include l___up {
						width: 248px;
						height: 443px;
						top: 94px;
						@include translateX(-505px);
					};
					
					&:after {
						background-image: url('#{$imgPathSCSS}shadow-4.png');
						background-position: left center;
					}
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// project-slider-2.vue?7bbfefca